App.filter('typePersonFilter', function () {
    return function (el) {
        el = el || '';

        var dictionary = [];
        
        dictionary['USER'] = 'Pracownik';
        dictionary['SPOUSE'] = 'Małżonek';
        dictionary['PARTNER'] = 'Partner';
        dictionary['CHILD'] = 'Pełnoletnie dziecko';

        if (el) {
        	if (dictionary[el]) {
        		return dictionary[el];
        	} else {
        		return el;
        	}
        }

        return el;
    };
})